<ng-container
  *ngIf="{ value: (parentControl?.invalid || innerControl?.invalid) && (innerControl.touched || innerControl.dirty) } as showInvalid"
>
  <label *ngIf="label" id="input-label-{{ _idSuffix }}" class="mb-2">{{ label }}</label>
  <div class="form-input" [ngClass]="{ invalid: showInvalid.value }">
    <input
      *ngIf="inputType === 'input'; else textarea"
      name="variable-input"
      type="text"
      [attr.aria-describedby]="'input-hint-' + _idSuffix"
      [attr.aria-labelledby]="'input-label-' + _idSuffix"
      [formControl]="innerControl"
      [placeholder]="placeholder"
      autocomplete="false"
    />
    <ng-template #textarea>
      <textarea
        name="variable-input"
        type="text"
        [attr.aria-describedby]="'input-hint-' + _idSuffix"
        [attr.aria-labelledby]="'input-label-' + _idSuffix"
        [formControl]="innerControl"
        [placeholder]="placeholder"
        autocomplete="false"
      >
      </textarea>
    </ng-template>
    <div class="insert-variable">
      <button type="button" [matMenuTriggerFor]="variableInsert" [disabled]="isDisabled" [ngClass]="{ 'cursor-default': isDisabled }">
        Insert Variable
        <anduin-icon name="chevron-down" aria-hidden="true" height="20" width="20" />
      </button>
      <mat-menu #variableInsert="matMenu" class="single-menu-item-per-row" [attr.id]="'variable-insert-' + _idSuffix">
        <button *ngFor="let variableOption of variables$ | async" type="button" (click)="appendVariable(variableOption[1])">
          {{ variableOption[0] }}
        </button>
      </mat-menu>
    </div>
  </div>
  <mat-hint *ngIf="hint" id="input-hint-{{ _idSuffix }}">{{ hint }}</mat-hint>
  <ng-container *ngIf="showInvalid.value">
    <mat-error *ngIf="innerControl?.errors?.variable">
      {{ innerControl.errors.variable }}
    </mat-error>
  </ng-container>
</ng-container>
